<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Statement Of Account</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-radio-group
                  v-model="filter_type"
                  row
                  class="ma-0"
                  justify-center
                >
                  <v-radio label="By Partner" value="PRT"></v-radio>
                  <v-radio label="By Ledger" value="LGD"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="px-2">
              <v-col
                cols="12"
                lg="3"
                sm="6"
                xs="12"
                v-if="filter_type == 'PRT'"
              >
                <v-autocomplete
                  class="rounded"
                  v-model="filterList.partner_id_prm"
                  dense
                  outlined
                  :rules="FieldRequired('Partner')"
                  label="Partner"
                  :items="senderPartners"
                  item-text="txt"
                  item-value="val"
                  placeholder="Select Partner"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                sm="6"
                xs="12"
                v-if="filter_type == 'LGD'"
              >
                <v-autocomplete
                  class="rounded"
                  v-model="filterList.ledger_id_prm"
                  dense
                  outlined
                  item-text="text"
                  item-disabled="had_sub_list"
                  item-value="value"
                  placeholder="Select ledger head"
                  @change="mapCurrency(filterList.ledger_id_prm)"
                  :rules="FieldRequired('Ledger Head')"
                  :items="ledgerIds"
                >
                  <template v-slot:item="data">
                    <template class="border">
                      <v-list-item
                        dense
                        ripple
                        @mousedown.prevent
                        :class="
                          data.item.had_sub_list
                            ? 'light-gray primary--text'
                            : ''
                        "
                        v-if="data.item.isheader"
                      >
                        <v-list-item-content class="ma-0 pa-0">
                          <v-list-item-title class="d-flex ma-0 pa-0"
                            ><span class="pt-1 ps-3 font-weight-bold">{{
                              data.item.text
                            }}</span></v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        dense
                        class="ps-6 border-list"
                        v-if="!data.item.isheader"
                      >
                        <v-list-item-content class="ma-0 ps-6 mt-2">
                          <v-list-item-title
                            ><v-icon class="pb-2">mdi-arrow-right-bottom</v-icon
                            >{{ data.item.text }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <v-divider></v-divider>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.currency"
                  :items="partnerCurrency"
                  :rules="FieldRequired('currency')"
                  placeholder="Select currency type"
                  label="Currency"
                  item-text="txt"
                  item-value="val"
                  outlined
                  dense
                  class="rounded"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.fromdate"
                  label="From Date"
                  :rules="FieldRequired('From Date')"
                  @input="filterList.fromdate"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.todate"
                  type="date"
                  :rules="FieldRequired('To Date')"
                  label="To Date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  v-model="filterList.viewtype"
                  class="rounded"
                  :rules="FieldRequired('Report View Type')"
                  label="Report View Type"
                  dense
                  outlined
                  item-text="txt"
                  item-value="val"
                  :items="reportViewTypes"
                  placeholder="Select Report View Type"
                ></v-autocomplete>
              </v-col>
              <v-btn
                depressed
                @click="getReportResults()"
                class="mr-2 mt-1"
                color="primary"
                small
                >Get Results
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-row class="ma-1 px-2 mt-2">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="mt-1"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Type here to filter values."
          hide-details
          rounded
          outlined
          dense
          clearable
          class="mt-2"
        ></v-text-field>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="userList"
        :search="search"
        :loading="loaderOverlay"
        loading-text="Loading please wait...."
        no-data-text="No data available."
        item-key="Pin_Number"
        dense
        class="mt-3"
        :items-per-page="-1"
      >
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import { FieldRequired } from "@/utils/validation.js";
// import commonService from "@/services/CommonService/commonService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import alerts from "@/mixins/alerts";
import reportingService from "@/services/ReportingService/reportingService.js";
import setupService from "@/services/SetupService/setupService";

export default {
  mixins: [alerts],
  name: "Transaction Report",
  data: () => {
    return {
      FieldRequired,
      headers: [],
      filter_type: "PRT",
      filterList: {
        partner_id_prm: null,
        ledger_id_prm: null,
        currency: "",
        fromdate: new Date().toISOString().substr(0, 10),
        todate: new Date().toISOString().substr(0, 10),
        viewtype: "D",
      },
      userList: [],
      ledgerIds: [],
      senderPartners: [],
      partnerCurrency: [
        {
          txt: "Settlement Currency",
          val: 1,
        },
        {
          txt: "Local Currency",
          val: 2,
        },
        {
          txt: "MYR",
          val: 3,
        },
      ],
      reportViewTypes: [
        {
          txt: "Detail Report",
          val: "D",
        },
        {
          txt: "Summary Report",
          val: "S",
        },
      ],
      search: "",
      loaderOverlay: false,
      valid: false,
    };
  },
  watch: {
    filter_type(val) {
      if (val === "PRT") {
        this.filterList.partner_id_prm = null;
        this.filterList.ledger_id_prm = null;
      } else if (val == "LGD") {
        this.filterList.ledger_id_prm = null;
        this.filterList.partner_id_prm = null;
        this.partnerCurrency = [];
      }
    },
  },
  mounted() {
    this.getAllSendPartners();
    this.getallLedgersDropdown();
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(
          this.headers,
          this.userList,
          "Statement of Account report"
        );
      }
    },
    mapCurrency(lgd_id) {
      if (lgd_id) {
        const lgdcny = this.ledgerIds.filter((ele) => ele.value == lgd_id);
        console.log(lgdcny);
        if (lgdcny && lgdcny[0].currency) {
          this.partnerCurrency.push({
            txt: lgdcny[0].currency,
            val: 2,
          });
        }
      }
    },
    async getallLedgersDropdown() {
      try {
        const responseData = await setupService.getallLedgersDropdown();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((ele) => {
            this.ledgerIds.push({
              text: ele.name,
              value: ele.ledger_id,
              currency: ele.currency_code,
              isheader: true,
              had_sub_list: ele.sub_ledger_list.length > 0 ? true : false,
            });
            if (ele.sub_ledger_list.length > 0) {
              ele.sub_ledger_list.map((sub_ele) => {
                this.ledgerIds.push({
                  text: sub_ele.name,
                  value: sub_ele.ledger_id,
                  currency: ele.currency_code,
                  isheader: false,
                });
              });
            }
          });
          console.log("this.ledgerIds", this.ledgerIds);
        }

        this.ledger_obj = responseData.data.data;
      } catch (e) {
        console.error(e);
      }
    },
    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getPartnersbymainsendprt();
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
          // this.senderPartners.unshift({
          //   txt: "All",
          //   val: "All",
          // });
        }
        console.log("payments", this.senderPartners);
      } catch (e) {
        console.error(e);
      }
    },
    // async getPartnerCurrency(id) {
    //   console.log(id);
    //   if (id) {
    //     try {
    //       const response = await partnerService.getallAllowpartnerCurrency(id);
    //       if (response.data.status_code === 200) {
    //         console.log("Currency", response.data.data);
    //         this.partnerCurrency = response.data.data.map((i) => {
    //           return { txt: i.currency_code, val: i.currency_code };
    //         });
    //         this.partnerCurrency.unshift({
    //           txt: "Settlement Currency",
    //           val: "1",
    //         });
    //       }
    //     } catch (error) {
    //       console.error("Error fetching :", error);
    //     }
    //   }
    // },
    async getReportResults() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const response = await reportingService.getSOAReport(this.filterList);
          if (response.status === 200) {
            this.loaderOverlay = false;
            const ObjKeys = Object.keys(response.data.data[0]);
            this.headers = ObjKeys.map((ele) => {
              return {
                text: ele,
                value: ele,
                sortable: false,
              };
            });
            this.userList = response.data.data;
          } else {
            this.loaderOverlay = false;
          }
        } catch (error) {
          this.loaderOverlay = false;
          console.error(error);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
